$(document).off("change", "#contract-select")
$(document).on("change", "#contract-select", function(){
  $("#contract-end-date").attr("disabled", "disabled")

  if ($("#contract-select option:selected").attr("is_permanent") == "0") {
    $("#contract-end-date").removeAttr("disabled", "disabled")
  }
})